var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-status"},[_c('v-icon',{attrs:{"color":"#243746","small":""}},[_vm._v("mdi-check")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }